export default {
	COMMAND_RESPONSE: 'command-response',
	NETWORK_STATUS: 'network-status',
	LIVE_STREAMING: 'live-streaming',
};
